
import  axios  from 'axios';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE} from "../towjob/actions";
import {loadTowCompanyTruckDataInStore} from "../towcompanytruck/actions";


export const LOAD_MESSAGE_DATA = 'message/LOAD_MESSAGE_DATA';
export const DELETE_A_MESSAGE = 'message/DELETE_A_MESSAGE';
export const SAVE_A_MESSAGE = 'message/SAVE_A_MESSAGE';
export const UPDATE_A_MESSAGE = 'message/UPDATE_A_MESSAGE';
export const CLEAR_A_MESSAGE_ERROR_MESSAGE = 'message/CLEAR_A_MESSAGE_ERROR_MESSAGE';


export function clearMessageErrorMsgInStore(){
    return {
        type: CLEAR_A_MESSAGE_ERROR_MESSAGE,
        
    }
}
export function loadMessageDataInStore(argMessageDataArray) {
    return {
        type: LOAD_MESSAGE_DATA,
        messagesData:argMessageDataArray
    }
}
export function deleteAMessageDataInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_MESSAGE,
        deleteMessageResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAMessageDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_MESSAGE,
        saveMessageResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAMessageDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_MESSAGE,
        updateMessageResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/

//****************************************
//Below is for update a Stream
//****************************************

export function clearMessageErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearMessageErrorMsgInStore());
    }
}
export function updateAMessage(argURL, argCamera) {
    return (dispatch, getState) => {

        updateAMessageOnServer(argURL, argCamera).then(function(saveResponse){

            dispatch(saveAMessageDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a message" + err.response.data);
            dispatch(saveAMessageDataInStore({}, err.response.data));
        });
    }//end of return
}


function updateAMessageOnServer( argURL, argCamera){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAMessage(argURL, argCamera)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a messages " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAMessage(argURL, argCamera ){
    /*
     I build something like this :
     http://localhost:4567/messages
     */

    let baseUrl = argURL+"messages";
    console.log(" on posting a messageies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argCamera ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAMessage(argURL, argCamera, argVehicle, argTowId) {
    return (dispatch, getState) => {

        saveAMessageOnServer(argURL, argCamera).then(function(saveResponse){

            dispatch(saveAMessageDataInStore(saveResponse, {}));
            
            //I used to load the messages after each save, but since I hav ewebsockets, I don't need to do that.
            // Farshid dispatch(loadMessagesData(argURL, argVehicle, argTowId));

        }, function(err){
            console.log("I had an error saving a message" + err.response.data);
            dispatch(saveAMessageDataInStore({}, err.response.data));
        });
    }//end of return
}


function saveAMessageOnServer( argURL, argCamera){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAMessage(argURL, argCamera)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a messages " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAMessage(argURL, argCamera ){
    /*
     I build something like this :
     http://localhost:4567/messages
     */

    let baseUrl = argURL+"messages";
    console.log(" on posting a messageies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a message
//****************************************
export function deleteAMessage(argURL, argCameraId) {
    return (dispatch, getState) => {

        deleteAMessageOnServer(argURL, argCameraId).then(function(deleteResponse){

            dispatch(deleteAMessageDataInStore(deleteResponse, null));

        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAMessageDataInStore({}, err));
        });
    }//end of return
}


function deleteAMessageOnServer( argURL, argStreamId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAMessage(argURL, argStreamId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a message " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAMessage(argURL, argStreamId ){


    let baseUrl = argURL+"messages"+"/"+argStreamId;
    console.log(" on deleteing a message the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl));
    }
    return arrayOfGets;
}

export function addMessageToMessagesArray(argMessagesArray ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempMessageArray=[] ;
        //tempTruckArray = Object.assign(tempTruckArray,state.message.messagesArray);
        //adding to the top of the array.
        //tempMessageArray.push(argMessagesArray);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadMessageDataInStore(argMessagesArray));
    }//end of return
}
//Get list of messages

export function loadMessagesData(argURL, argVehicle, argTowId) {
    return (dispatch, getState) => {

        getListOfMessages(argURL, argVehicle, argTowId).then(function(messagesList){

            dispatch(loadMessageDataInStore(messagesList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfMessages(argURL, argVehicle, argTowId ){
    /*
     I build something like this :
     http://localhost:4567/message
     */

    let baseUrl = argURL+"messages/allmessages/"+ argTowId ;
    console.log(" on getting list of Messages  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl, argVehicle));
    }
    return arrayOfGets;
}

function getListOfMessages( argURL, argVehicle, argTowId){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfMessages(argURL, argVehicle, argTowId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Messages " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


function getMessageDataFromRemoteServer( argURL, argMessagesList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argMessagesList != null){

            axios.all(getArrayOfGets(argURL, argMessagesList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}

function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;

    /*

     I need to build something like this :

     http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/GRAPHS/farm_summary?farmId=f1
     */

    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Message DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

/*
export function loadMessageData(argURL) {
    return (dispatch, getState) => {


        var arrayOfMessageData=[];
        getListOfMessages(argURL).then(function(messagesList){

            for(var z=0; z<messagesList.length; z++){

                let singleResponse = messagesList[z];
                let responseData = singleResponse.data;
                getMessageDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfMessageData.push(farmsData[i].data);
                    }
                    dispatch(loadMessageDataInStore(arrayOfMessageData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                }); 

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */